<template>
  <div class="tab-main">
    <div class="tip">
      经工商行政管理部门登记，有营业执照的个体工商户
    </div>
    <el-form label-position="right"
             class="fast-login top-40"
             :model="dataForm"
             :rules="dataRule"
             label-width="150px"
             ref="dataForm"
             status-icon>
      <el-form-item label="企业名称："
                    prop="companyName">
        <el-input v-model="dataForm.companyName"
                  placeholder="请输入企业名称"
                  :maxlength="50"
                  clearable></el-input>
      </el-form-item>
      <el-form-item label="统一社会信用代码："
                    prop="socialCreditCode">
        <el-input v-model="dataForm.socialCreditCode"
                  placeholder="请输入统一社会信用代码"
                  :maxlength="18"
                  clearable
                  oninput="value=value.replace(/[^A-Za-z0-9]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="所属行业："
                    prop="industry">
        <el-cascader v-model="dataForm.industry"
                          :options="industryList"
                          collapse-tags
                          style="width: 100%"
                          clearable
                          :props="defaultParams"></el-cascader>
      </el-form-item>
      <el-form-item label="经营地址："
                    prop="provinceId">
        <el-select v-model="dataForm.provinceId"
                    style="width: 30%;float:left"
                    @change="changeProvince"
                    placeholder="省">
          <el-option v-for="item in provinceList"
                      :key="item.codeP"
                      :label="item.name"
                      :value="item.codeP">
          </el-option>
        </el-select>
        <el-select v-model="dataForm.cityId"
                    style="width: 30%;float:left;margin-left:5%"
                    @change="changeCity"
                    placeholder="市">
          <el-option v-for="item in cityList"
                      :key="item.codeC"
                      :label="item.name"
                      :value="item.codeC">
          </el-option>
        </el-select>
        <el-select v-model="dataForm.areaId"
                    style="width: 30%;float:left;margin-left:5%"
                    placeholder="区">
          <el-option v-for="item in areaList"
                      :key="item.codeA"
                      :label="item.name"
                      :value="item.codeA">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label=""
                    prop="address">
        <el-input v-model="dataForm.address"
                  placeholder="详细地址：如街道，道路，园区，门牌号等"
                  clearable></el-input>
      </el-form-item>
      <el-form-item label="经营者："
                    prop="legaPerson">
        <el-input v-model="dataForm.legaPerson"
                  placeholder="请输入经营者姓名"
                  :maxlength="4"></el-input>
      </el-form-item>
      <el-form-item label="经营者身份证："
                    prop="legaIdcard">
        <el-input v-model="dataForm.legaIdcard"
                  placeholder="请输入经营者身份证"
                  clearable></el-input>
      </el-form-item>
      <el-form-item label="上传营业执照：">
        <div class="upLoad-but" v-show="businessLicenseUrl">
          <img :src="businessLicenseUrl" width="150px" height="100px"/>
          <i class="el-icon-delete delete" @click="deleteHandle(businessLicenseId, 'businessLicense')"></i>
        </div>
        <el-upload class="upload-demo"
                   :action="actionUrl"
                   :show-file-list="false"
                   :data="businessLicenseData"
                   :accept="'.jpg,.bmp,.gif,.jpeg,.png,.pdf'"
                   :with-credentials="true"
                   :headers="upLoadHeaders"
                   :on-success="handlebusinessLicenseSuccess"
                   :before-upload="beforeBusinessLicenseUpload">
                   <el-button class="upLoad-but" size="small" icon="el-icon-plus" v-show="!businessLicenseId"></el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="上传经营者身份证：">
        <el-col :span="11">
          <div class="upLoad-but" v-show="IdcardFrontUrl">
            <img :src="IdcardFrontUrl" width="150px" height="100px"/>
            <i class="el-icon-delete delete" @click="deleteHandle(IdcardFrontId, 'IdcardFront')"></i>
          </div>
          <el-upload class="upload-demo"
                     :action="actionUrl"
                     :accept="'.jpg,.bmp,.gif,.jpeg,.png,.pdf'"
                     :show-file-list="false"
                     :data="IDcardAdata"
                     :with-credentials="true"
                     :headers="upLoadHeaders"
                     :on-success="handleIdcardFrontSuccess"
                     :before-upload="beforeUpload">
            <el-button class="upLoad-but" size="small" icon="el-icon-plus" v-show="!IdcardFrontId"></el-button>
          </el-upload>
        </el-col>
        <el-col :span="11">
          <div class="upLoad-but" v-show="IdcardBackUrl">
            <i class="el-icon-delete delete" @click="deleteHandle(IdcardBackId, 'IdcardBack')"></i>
            <img :src="IdcardBackUrl" width="150px" height="100px"/>
          </div>
          <el-upload class="upload-demo"
                     :action="actionUrl"
                     :accept="'.jpg,.bmp,.gif,.jpeg,.png,.pdf'"
                     :show-file-list="false"
                     :data="IDcardBdata"
                     :with-credentials="true"
                     :headers="upLoadHeaders"
                     :on-success="handleIdcardBackSuccess"
                     :before-upload="beforeUpload">
            <el-button class="upLoad-but" size="small" icon="el-icon-plus" v-show="!IdcardBackId"></el-button>
          </el-upload>
        </el-col>
      </el-form-item>
      <el-form-item label="">
        <div class="tip-upload">
          <div>上传提示：</div>
          <div>照片所有信息需清晰可见，内容真实有效，不得做任何修改。</div>
          <div>照片支持上传.jpg .jpeg .bmp .gif .png格式，大小不超过8M</div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script >
import validate from '@/utils/validate'
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      actionUrl: window.SITE_CONFIG['apiURL'] + '/help/fileupload/sys/v2/upload',
      upLoadHeaders: {
        'Authorization': 'Bearer ' + getAccessToken()
      },
      dataForm: {
        // companyId: '',
        nature: '30', // 企业性质 10企业，20政府事业单位，30个体工商户，40其他
        companyName: '', // 企业名称
        socialCreditCode: '', // 统一社会信用代码
        industry: [],
        provinceId: '',
        cityId: '',
        areaId: '',
        address: '',
        legaPerson: '', // 企业法人
        legaIdcard: '', // 法人身份证
        fileList: []
      },
      businessLicenseId: '', // 营业执照
      businessLicenseUrl: '', // 营业执照Url
      IdcardFrontId: '', // 身份证正面
      IdcardFrontUrl: '', // 身份证正面Url
      IdcardBackId: '', // 身份证反面
      IdcardBackUrl: '', // 身份证反面Url
      businessLicenseData: {
        FILE_TYPE: 20, // 营业执照
        fileSuffixType: 'picture2'
      },
      IDcardAdata: {
        FILE_TYPE: 301, // 身份证正面
        fileSuffixType: 'picture2'
      },
      IDcardBdata: {
        FILE_TYPE: 302, // 身份证反面
        fileSuffixType: 'picture2'
      },
      // 行业树 props
      defaultParams: {
        label: 'industryName',
        value: 'industryId',
        children: 'children'
      },
      // 省市区
      provinceList: [],
      cityList: [],
      areaList: []
    }
  },
  props: {
    industryList: { // 行业列表
      type: Array,
      default: () => []
    },
    companyName: {
      type: String,
      default: ''
    }
  },
  watch: {
    'companyName': {
      handler: 'changeCompanyName',
      immediate: true
    }
  },
  computed: {
    dataRule () {
      var validateProvinceId = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请选择省'))
        } else if (!this.dataForm.cityId) {
          return callback(new Error('请选择市'))
        } else if (!this.dataForm.areaId) {
          return callback(new Error('请选择区'))
        } else {
          callback()
        }
      }
      var validateSocialCreditCode = (rule, value, callback) => {
        if (value && !(value.length === 15 || value.length === 18)) {
          return callback(new Error('长度在 15 或 18 个大小写字母或者数字'))
        } else {
          callback()
        }
      }
      return {
        companyName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        socialCreditCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          // { min: 15, max: 18, message: '长度在 15 到 18 个大小写字母或者数字', trigger: 'blur' }
          { validator: validateSocialCreditCode, trigger: 'blur' }
        ],
        provinceId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: validateProvinceId, trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        legaPerson: [
          // { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { min: 2, max: 4, message: '长度在 2 到 4 个汉字', trigger: 'blur' }
        ],
        legaIdcard: [
          // { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: validate.validateIdCard, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
  },
  mounted () {
    this.getProvinceList()
  },
  methods: {
    getProvinceList () {
      this.$http.post('/help/sys/sysProvince/queryList', {}).then(({ data: res }) => {
        this.provinceList = res.data
      }).catch(() => { })
    },
    changeCompanyName () {
      this.dataForm.companyName = this.companyName
    },
    // 选择省
    changeProvince () {
      this.dataForm.cityId = ''
      this.dataForm.areaId = ''
      this.cityList = []
      this.areaList = []
      this.$http.post('/help/sys/sysCity/queryList', { codeP: this.dataForm.provinceId })
        .then(({ data: res }) => {
          this.cityList = res.data
        }).catch(() => { })
    },
    // 选择市
    changeCity () {
      this.dataForm.areaId = ''
      this.areaList = []
      this.$http.post('/help/sys/sysArea/queryList', { codeC: this.dataForm.cityId })
        .then(({ data: res }) => {
          this.areaList = res.data
        }).catch(() => { })
    },
    // 校验图片格式
    beforeUpload (file) {
      let type = file.name.substring(file.name.lastIndexOf('.'))
      const isLt2M = file.size / 1024 / 1024 < 8
      var reg = /\.(jpg|bmp|gif|jpeg|png|pdf)$/
      const isJPG = reg.test(type)

      if (!isJPG) {
        this.$message.error('上传文件只能是 jpg|bmp|gif|jpeg|png 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 8MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
      return isJPG && isLt2M
    },
    // 校验营业执照
    beforeBusinessLicenseUpload (file) {
      let type = file.name.substring(file.name.lastIndexOf('.'))
      const isLt2M = file.size / 1024 / 1024 < 20
      var reg = /\.(jpg|bmp|gif|jpeg|png|pdf)$/
      const isJPG = reg.test(type)

      if (!isJPG) {
        this.$message.error('上传文件只能是 jpg|bmp|gif|jpeg|png 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    // 上传营业执照
    handlebusinessLicenseSuccess (res) {
      if (res.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.businessLicenseUrl = res.data.url
        this.businessLicenseId = res.data.aliOssId
      } else {
        this.$message({
          message: res.message,
          type: 'error'
        })
      }
    },
    // 上传法人身份证 正面
    handleIdcardFrontSuccess (res) {
      if (res.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.IdcardFrontUrl = res.data.url
        this.IdcardFrontId = res.data.aliOssId
      } else {
        this.$message({
          message: res.message,
          type: 'error'
        })
      }
    },
    // 上传法人身份证 反面
    handleIdcardBackSuccess (res) {
      if (res.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.IdcardBackUrl = res.data.url
        this.IdcardBackId = res.data.aliOssId
      } else {
        this.$message({
          message: res.message,
          type: 'error'
        })
      }
    },
    fomatDataForm () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let fileList = []
        if (this.businessLicenseId) {
          fileList.push({
            fileId: this.businessLicenseId,
            type: 20
          })
        }
        if (this.IdcardFrontId) {
          fileList.push({
            fileId: this.IdcardFrontId,
            type: 301
          })
        }
        if (this.IdcardBackId) {
          fileList.push({
            fileId: this.IdcardBackId,
            type: 302
          })
        }
        this.dataForm.fileList = fileList
        this.$emit('submitHandle')
      })
    },
    deleteHandle (id, key) {
      if (key) {
        this[key + 'Id'] = ''
        this[key + 'Url'] = ''
      }
      if (id) {
        this.$http.post(`/help/fileupload/sys/deleteAliOss`, {
          'aliOssId': id
        })
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.tab-main {
  width: 600px;
  padding: 20px 40px;
}
.tip-upload{
  color: rgba(153,153,153,0.615686274509804);
  line-height: 20px;
  font-size: 12px;
}
.tip {
  font-size: 14px;
  color: #999999;
}
.upLoad-but{
  width: 150px;
  height: 100px;
  position: relative;
  .delete{
    color: #fff;
    position: absolute;
    right: 50%;
    top: 50%;
    cursor: pointer;
  }
}
</style>
